export const pushActions = {
  Typing: 'Typing',
  OwnershipChanged: 'OwnershipChanged',
  MessageReceived: 'MessageReceived',
  InternalUpdate: 'InternalUpdate',
  NavigateTo: 'NavigateTo' // a worker-client action type
}

export const pushHubs = {
  Service: 'Service',
  Sales: 'Sales',
  Review: 'Review'
}

export const messagingKindsToPaths = {
  Service: 'messaging',
  Sales: 'incoming',
  Review: 'feedback'
}

export const pushUnits = {
  Chat: 'Chat'
}

export const categoryNames = {
  AgentResponded: 'Waiting for guest response', // AgentResponded
  ClientWaiting: 'Guest is waiting', // ClientWaiting
  Closed: 'Resolved',
  StartedManually: 'New conversations',
  Rated: 'Guest rated'
}

const sortParams = {
  time: 'time',
  roomNo: 'roomNo',
  guestName: 'guestName'
}

export const sortNames = {
  time: 'Last message time',
  roomNo: 'Room number',
  guestName: 'Guest name'
}

export const subscriptionStatusTypes = {
  ConsentGiven: 'Opted-in',
  DoNotCall: 'Opted-out',
  Active: 'Active',
  BrandExcluded: 'Brand Excluded'
}

const otpBotIntent = 'Otp'

export const sortThreads = sortParam => (a, b) => {
  if (sortParam === sortParams.guestName) {
    return a.subscriber >= b.subscriber ? 1 : -1
  }

  if (sortParam === sortParams.time) {
    return Date.parse(a.lastMessageOn) >= Date.parse(b.lastMessageOn) ? -1 : 1
  }

  if (sortParam === sortParams.roomNo) {
    return Number(a.roomNumber) - Number(b.roomNumber)
  }

  return 0
}

// Verification code messages reaching during-stay and other hotel inboxes belong to a third
// party, so they stay hidden from hotel staff on those pages. Before stay shows them.
export function isUnidentifiedOtpThread(thread) {
  if (!thread || thread.lastMessageBotIntent !== otpBotIntent) {
    return false
  }

  return !thread.subscriber || !thread.subscriber.trim()
}

export function getStoreNameFromMessagingType(messagingType) {
  switch (messagingType) {
    case 'sales':
      return 'salesMessaging'

    case 'service':
      return 'serviceMessaging'

    case 'review':
      return 'reviewMessaging'

    case 'direct':
      return 'directMessaging'

    default:
      return null
  }
}

export function getChatRouteFromMessagingType(messagingType) {
  switch (messagingType) {
    case 'sales':
      return '/incoming'

    case 'service':
      return '/messaging'

    case 'review':
      return '/feedback'

    case 'direct':
      return '/direct'

    default:
      return null
  }
}
